
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f8JZq", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");





var $jFPud = parcelRequire("jFPud");





var $8ioQN = parcelRequire("8ioQN");







var $1907b13141068223$export$2e2bcd8739ae039 = ()=>{
    const mountedRef = (0, $42omo.useRef)(false);
    // Track if a component is mounted or not.
    (0, $42omo.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    // Changes in ref values don't cause re renders. So evaluate this inside a CB so that hooks that use this can reliably update themselves.
    return (0, $42omo.useCallback)(()=>mountedRef.current, []);
};


const $5bd0a20767da26b5$var$_default = ()=>{
    const isMounted = (0, $1907b13141068223$export$2e2bcd8739ae039)();
    return (0, $42omo.useCallback)((promise)=>new Promise((resolve, reject)=>{
            promise.then((result)=>{
                if (isMounted()) resolve(result);
            }).catch((error)=>{
                if (isMounted()) reject(error);
            });
        }), [
        isMounted
    ]);
};
var $5bd0a20767da26b5$export$2e2bcd8739ae039 = $5bd0a20767da26b5$var$_default;






var $czt8s = parcelRequire("czt8s");

const $263d677a2a746b1c$export$4b957095b7ba85f6 = ()=>{
    const previousPromise = (0, $42omo.useRef)(null);
    return (0, $42omo.useCallback)((promise)=>{
        if (previousPromise.current) previousPromise.current.cancel();
        const cancellablePromise = (0, $czt8s.CancellablePromise).from(promise);
        previousPromise.current = cancellablePromise;
        return cancellablePromise.promise();
    }, []);
};
var $263d677a2a746b1c$export$2e2bcd8739ae039 = $263d677a2a746b1c$export$4b957095b7ba85f6;






var $2ZIpG = parcelRequire("2ZIpG");


var $2jE99 = parcelRequire("2jE99");


var $cgH2x = parcelRequire("cgH2x");


var $kmpep = parcelRequire("kmpep");


var $4TXTZ = parcelRequire("4TXTZ");


var $kJsRi = parcelRequire("kJsRi");

const $e45a5214d4dda8fa$export$8f4061f7e3425391 = ({ id: id, setState: setState, searchItemSupplier: searchItemSupplier, setAPIState: setAPIState, ufoExperience: ufoExperience, reactUFOExperience: reactUFOExperience, debounceTime: debounceTime })=>{
    const generateCancelledPromiseOnunmount = (0, $5bd0a20767da26b5$export$2e2bcd8739ae039)();
    const generateMaxOneInflightRequest = (0, $263d677a2a746b1c$export$2e2bcd8739ae039)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    const presentQuery = (0, $42omo.useRef)(query);
    const presentFilters = (0, $42omo.useRef)(filterDefinitions);
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId || '';
    (0, $42omo.useEffect)(()=>{
        presentQuery.current = query;
        presentFilters.current = filterDefinitions;
    }, [
        query,
        filterDefinitions
    ]);
    return (0, $42omo.useCallback)((arg)=>{
        return new Promise((resolve, reject)=>{
            if (reactUFOExperience) (0, $4TXTZ.default)(`${id}-${reactUFOExperience}`, performance.now() - (debounceTime || 0));
            setAPIState((0, $jFPud.APIStates).Loading);
            ufoExperience.start();
            generateMaxOneInflightRequest(generateCancelledPromiseOnunmount(searchItemSupplier(arg))).then((response)=>{
                if (presentQuery.current !== query) {
                    ufoExperience.abort();
                    return;
                }
                ufoExperience.success({
                    metadata: {
                        cloudId: cloudId
                    }
                });
                setState(response);
                if ((0, $2jE99.hasSearchResults)(response)) setAPIState((0, $jFPud.APIStates).Success);
                else setAPIState((0, $jFPud.APIStates).NoResult);
                resolve(response);
            }).catch((e)=>{
                if (presentQuery.current !== query) {
                    ufoExperience.abort();
                    return;
                }
                /**
						 * Set state only if the promise was not cancelled, which happens only to avoid multiple calls going out.
						 */ if (e && !e.isCancelled) {
                    setState((0, $8ioQN.EMPTY_SEARCH_ITEMS));
                    setAPIState((0, $jFPud.APIStates).Error);
                    const errorName = typeof e.name === 'string' ? e.name : 'Error';
                    const errorMessage = typeof e.message === 'string' ? e.message : 'request failed';
                    const err = e;
                    ufoExperience.failure({
                        metadata: {
                            cloudId: cloudId,
                            productId: id,
                            errorName: errorName,
                            errorMessage: errorMessage.slice(0, 500),
                            statusCode: err.status ?? err.response?.status
                        }
                    });
                    if (reactUFOExperience) (0, $kJsRi.setInteractionError)(`${id}-${reactUFOExperience}`, {
                        errorMessage: errorMessage,
                        name: errorName
                    });
                    reject(e);
                } else if (e.isCancelled) ufoExperience.abort();
            });
        });
    }, [
        reactUFOExperience,
        setAPIState,
        ufoExperience,
        generateMaxOneInflightRequest,
        generateCancelledPromiseOnunmount,
        searchItemSupplier,
        id,
        debounceTime,
        query,
        cloudId,
        setState
    ]);
};



var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");








var $5dFS9 = parcelRequire("5dFS9");





var $6dP89 = parcelRequire("6dP89");


var $fJRVo = parcelRequire("fJRVo");


var $gF7Az = parcelRequire("gF7Az");







const $234aaf176f575a9f$var$unavailable = 'UNAVAILABLE';
const $234aaf176f575a9f$var$defaultItemLimit = 10;
const $234aaf176f575a9f$export$f21d1466a3cf3dc4 = (searchItems)=>{
    return searchItems.sections.map((section)=>({
            results: section.searchResults.slice(0, section?.resultLimit || $234aaf176f575a9f$var$defaultItemLimit).map((item)=>({
                    containerId: item.containerId || $234aaf176f575a9f$var$unavailable,
                    isRecentResult: !!item.isRecentResult,
                    resultContentId: item.id,
                    resultType: section.id
                })),
            sectionId: section.id
        }));
};


const $eb7d0d43181fe66d$export$31dcc804f49f716 = (productState, commonAttributes, previousState, preQueryItems)=>{
    if (previousState !== (0, $jFPud.ProductStates).PreQueryLoading) return;
    const results = (0, $234aaf176f575a9f$export$f21d1466a3cf3dc4)(preQueryItems);
    const attributes = (0, $5dFS9.onSearchResultsShown)({
        actionSubjectId: (0, $5dFS9.ResultsShownActionSubjectId).PREQUERY,
        resultCount: preQueryItems.size || 0,
        sectionCount: preQueryItems.sections.length,
        results: results,
        ...commonAttributes
    });
    switch(productState){
        case (0, $jFPud.ProductStates).PreQueryNoResult:
            return attributes;
        case (0, $jFPud.ProductStates).PreQuerySuccess:
            if (results.length > 0) return attributes;
            break;
        default:
            break;
    }
};









const $d704615f538f1c09$export$24483fbaea3e285c = (productState, commonAttributes, previousState, postQueryItems)=>{
    const results = (0, $234aaf176f575a9f$export$f21d1466a3cf3dc4)(postQueryItems);
    if (previousState !== (0, $jFPud.ProductStates).PostQueryLoading) {
        if ((previousState === (0, $jFPud.ProductStates).PreQuerySuccess || previousState === (0, $jFPud.ProductStates).PostQuerySuccess) && productState === (0, $jFPud.ProductStates).PostQueryLoading && results.length !== 0) return (0, $5dFS9.onSearchResultsShown)({
            actionSubjectId: (0, $5dFS9.ResultsShownActionSubjectId).CACHED,
            resultCount: postQueryItems.size || 0,
            sectionCount: postQueryItems.sections.length,
            results: results,
            experimentLayers: postQueryItems.experimentLayers,
            ...commonAttributes
        });
        return;
    }
    switch(productState){
        case (0, $jFPud.ProductStates).PostQueryNoResult:
        case (0, $jFPud.ProductStates).PostQuerySuccess || (0, $jFPud.ProductStates).PostQueryNoResult:
            return (0, $5dFS9.onSearchResultsShown)({
                actionSubjectId: (0, $5dFS9.ResultsShownActionSubjectId).POSTQUERY,
                resultCount: postQueryItems.size || 0,
                sectionCount: postQueryItems.sections.length,
                results: results,
                experimentLayers: postQueryItems.experimentLayers,
                ...commonAttributes
            });
        default:
            break;
    }
};



var $lfOhG = parcelRequire("lfOhG");

function $febd688bbfad68d7$export$d1a9a84f417d0e21(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $febd688bbfad68d7$export$5e1edcb3c154ab79 = (filters)=>{
    let filtersForAnalytics = {};
    filters.map((filter)=>{
        filtersForAnalytics = {
            ...filtersForAnalytics,
            [filter['@type']]: $febd688bbfad68d7$export$d1a9a84f417d0e21(filter.store.availableFilters)
        };
    });
    return filtersForAnalytics;
};








const $652b1eec8eed1371$export$9e18793b5595e1a7 = (productState, commonAttributes, previousState)=>{
    if (previousState !== (0, $jFPud.ProductStates).PreQueryLoading && previousState !== (0, $jFPud.ProductStates).PostQueryLoading) return;
    switch(productState){
        case (0, $jFPud.ProductStates).PreQueryError:
        case (0, $jFPud.ProductStates).PostQueryError:
            return (0, $5dFS9.onSearchResultsShown)({
                actionSubjectId: productState === (0, $jFPud.ProductStates).PreQueryError ? (0, $5dFS9.ResultsShownActionSubjectId).PREQUERY_ERROR : (0, $5dFS9.ResultsShownActionSubjectId).POSTQUERY_ERROR,
                resultCount: 0,
                sectionCount: 0,
                results: [],
                ...commonAttributes
            });
        default:
            break;
    }
};



var $l9vwB = parcelRequire("l9vwB");

const $28d34b46d5c2a630$export$4969b75c2e508ab8 = (productState, preQueryItems, postQueryItems)=>{
    $28d34b46d5c2a630$export$f024c9d2f0f4772f(productState, (0, $eb7d0d43181fe66d$export$31dcc804f49f716), preQueryItems);
    $28d34b46d5c2a630$export$f024c9d2f0f4772f(productState, (0, $d704615f538f1c09$export$24483fbaea3e285c), postQueryItems);
    $28d34b46d5c2a630$export$f024c9d2f0f4772f(productState, (0, $652b1eec8eed1371$export$9e18793b5595e1a7), {
        sections: [],
        size: 0
    });
};
const $28d34b46d5c2a630$export$361443716e90a194 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { products: products, getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const filters = (0, $lfOhG.useGetCurrentProductFilters)();
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const activeProduct = getActiveProduct();
    const isMultiProduct = products.length > 0;
    return [
        fireAnalyticsEvent,
        activeProduct,
        isExpanded,
        isMultiProduct,
        (0, $febd688bbfad68d7$export$5e1edcb3c154ab79)(filters)
    ];
};
const $28d34b46d5c2a630$export$f024c9d2f0f4772f = (productState, analyticsGenerator, searchItems)=>{
    const previousStateOfStateMachine = (0, $42omo.useRef)();
    const [fireAnalyticsEvent, activeProduct, isExpanded, isMultiProduct, filters] = $28d34b46d5c2a630$export$361443716e90a194();
    const { bitbucketWorkspacesCount: bitbucketWorkspacesCount, selectedBitbucketWorkspace: selectedBitbucketWorkspace } = (0, $l9vwB.useBitbucketWorkspacesData)();
    (0, $42omo.useEffect)(()=>{
        if (isExpanded && activeProduct && activeProduct.id !== '' && activeProduct.isDisplayed && previousStateOfStateMachine.current) {
            const commonAttributes = {
                activeProduct: activeProduct?.id,
                isMultiProduct: isMultiProduct,
                filters: filters,
                bitbucketWorkspacesCount: bitbucketWorkspacesCount,
                selectedBitbucketWorkspace: selectedBitbucketWorkspace
            };
            const payload = analyticsGenerator(productState, commonAttributes, previousStateOfStateMachine.current, searchItems);
            if (payload && Object.keys(payload).length > 0) fireAnalyticsEvent(payload);
        }
        previousStateOfStateMachine.current = productState;
    }, [
        productState,
        isExpanded,
        fireAnalyticsEvent,
        isMultiProduct,
        activeProduct,
        searchItems,
        analyticsGenerator,
        filters,
        bitbucketWorkspacesCount,
        selectedBitbucketWorkspace
    ]);
};


const $d24f29158109d053$export$b7e7046cf7397962 = ()=>{
    const [fireAnalyticsEvent, activeProduct, isExpanded, isMultiProduct, filters] = (0, $28d34b46d5c2a630$export$361443716e90a194)();
    const decorateWithTimings = (0, $42omo.useCallback)((postQueryItemSupplier)=>{
        return (args)=>{
            const start = new Date();
            return postQueryItemSupplier(args).then((result)=>{
                const end = new Date();
                const postQueryRequestDurationMs = end.getTime() - start.getTime();
                fireAnalyticsEvent((0, $5dFS9.onRequestMade)({
                    actionSubjectId: 'postQuerySearchResults',
                    timings: {
                        postQueryRequestDurationMs: postQueryRequestDurationMs
                    },
                    activeProduct: activeProduct?.id,
                    isExpanded: isExpanded,
                    isMultiProduct: isMultiProduct,
                    filters: filters,
                    experimentLayers: result.experimentLayers
                }));
                return result;
            });
        };
    }, [
        fireAnalyticsEvent,
        activeProduct?.id,
        isExpanded,
        isMultiProduct,
        filters
    ]);
    return decorateWithTimings;
};



var $jAnRi = parcelRequire("jAnRi");

const $078777d7fdf49344$export$c89ff2b708144e3c = ({ setAPIState: setAPIState, setState: setState, postQueryItemSupplier: postQueryItemSupplier, id: id, debounceTime: debounceTime })=>{
    const ufoPostQueryLoadExperience = (0, $42omo.useRef)(new (0, $5aVN7.UFOExperience)(`${id}-post-query-results-load`, {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: (0, $jAnRi.COMPONENT)
        }
    }));
    const decorateWithTimings = (0, $d24f29158109d053$export$b7e7046cf7397962)();
    const timedItemSupplier = (0, $42omo.useMemo)(()=>decorateWithTimings(postQueryItemSupplier), [
        postQueryItemSupplier,
        decorateWithTimings
    ]);
    const decoratedPostQuery = (0, $e45a5214d4dda8fa$export$8f4061f7e3425391)({
        id: id,
        setState: setState,
        setAPIState: setAPIState,
        ufoExperience: ufoPostQueryLoadExperience.current,
        reactUFOExperience: 'quick-search-post-query',
        debounceTime: debounceTime,
        searchItemSupplier: timedItemSupplier
    });
    return decoratedPostQuery;
};






var $3NyIw = parcelRequire("3NyIw");











class $8fe277ca7b8efb30$export$93648f64968deb06 extends (0, $5aVN7.UFOExperience) {
    start() {
        if (!this.startInvoked) {
            this.startInvoked = true;
            return super.start();
        }
        return Promise.resolve();
    }
    constructor(...args){
        super(...args);
        this.startInvoked = void 0;
    }
}


const $c008c398b65e94aa$export$1a0b61dc15626973 = ({ preQueryItemSupplier: preQueryItemSupplier, setAPIState: setAPIState, setState: setState, id: id })=>{
    const [preQueryCache] = (0, $42omo.useState)(new (0, $3NyIw.SimpleCache)(preQueryItemSupplier));
    const searchItemSupplier = (0, $42omo.useCallback)((args)=>preQueryCache.getAsync(args).value, [
        preQueryCache
    ]);
    const ufoPreQueryLoadExperience = (0, $42omo.useRef)(new (0, $8fe277ca7b8efb30$export$93648f64968deb06)(`${id}-pre-query-results-load`, {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: (0, $jAnRi.COMPONENT)
        }
    }));
    return (0, $e45a5214d4dda8fa$export$8f4061f7e3425391)({
        id: id,
        setState: setState,
        setAPIState: setAPIState,
        searchItemSupplier: searchItemSupplier,
        ufoExperience: ufoPreQueryLoadExperience.current
    });
};



var $jSnXV = parcelRequire("jSnXV");


var $a4TK8 = parcelRequire("a4TK8");













const $2f0fec97faec665d$var$useDebouncedState = ({ debounceTime: debounceTime })=>{
    const [triggerDebounce, setTriggerDebounce] = (0, $42omo.useState)(false);
    const debouncedSetter = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setTriggerDebounce(true);
        }, debounceTime), [
        debounceTime,
        setTriggerDebounce
    ]);
    return [
        triggerDebounce,
        setTriggerDebounce,
        debouncedSetter
    ];
};
const $2f0fec97faec665d$export$4dd234b8f57e873a = ({ debounceTime: debounceTime, query: query, analyticsInfo: analyticsInfo, filters: filters, workspaces: workspaces, sectionIds: sectionIds, isDisplayed: isDisplayed, postQueryItemSupplier: postQueryItemSupplier, setPostQueryItems: setPostQueryItems, setPostQueryAPIState: setPostQueryAPIState, preventDebouncedSearch: preventDebouncedSearch, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled })=>{
    // Store the previous isDisplayed for this product. It is initialised to
    // account for the case where the product is initially displayed. In this
    // case, we want to fire the postQueryItemSupplier immediately.
    const previousIsDisplayed = (0, $42omo.useRef)(false);
    // Store the previous query. The default here is an undefined string here to
    // support the case where the initial state of the component is a non-empty
    // string. In this case, we want to fire the postQueryItemSupplier
    // immediately.
    const previousQuery = (0, $42omo.useRef)(undefined);
    const previousFilters = (0, $42omo.useRef)(filters);
    const [triggerDebounce, setTriggerDebounce, debouncedSetter] = $2f0fec97faec665d$var$useDebouncedState({
        debounceTime: debounceTime
    });
    $2f0fec97faec665d$var$useResetPostQueryAPIStateOnEmptySearch({
        query: query,
        filters: filters,
        setPostQueryAPIState: setPostQueryAPIState,
        isDisplayed: isDisplayed,
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled
    });
    $2f0fec97faec665d$var$useResetPostQueryItemOnNewSearch({
        query: query,
        filters: filters,
        setPostQueryItems: setPostQueryItems,
        setPostQueryAPIState: setPostQueryAPIState,
        isDisplayed: isDisplayed,
        debouncedSetter: debouncedSetter,
        sectionIds: sectionIds,
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled
    });
    (0, $42omo.useEffect)(()=>{
        const queryChanged = query !== previousQuery.current;
        const filtersChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousFilters.current, filters);
        const isDisplayedChanged = previousIsDisplayed.current === false && isDisplayed;
        const search = query || isPreQueryFiltersEnabled && filters.length;
        if (preventDebouncedSearch && search && isDisplayed) {
            if (queryChanged) {
                previousQuery.current = query;
                setPostQueryAPIState((0, $jFPud.APIStates).Typing);
            }
            if (isDisplayedChanged || filtersChanged) {
                previousFilters.current = filters;
                postQueryItemSupplier({
                    query: query,
                    filters: filters,
                    analyticsInfo: analyticsInfo,
                    sectionIds: sectionIds,
                    workspaces: workspaces
                }).catch((ignore)=>{});
            }
        } else if (// Fire when debounce is finished or when product becomes active
        (triggerDebounce || isDisplayedChanged) && // Fire when search parameters change or when product becomes active
        (queryChanged || filtersChanged) && search && isDisplayed && sectionIds) {
            previousQuery.current = query;
            previousFilters.current = filters;
            postQueryItemSupplier({
                query: query,
                filters: filters,
                analyticsInfo: analyticsInfo,
                sectionIds: sectionIds,
                workspaces: workspaces
            }).catch((ignore)=>{});
            setTriggerDebounce(false);
        }
        previousIsDisplayed.current = isDisplayed;
        // In the case of an empty query /  no filters-only search, we want to reset any previous query caches
        // Still potentially not optimal as you would not get the cache behaviour if you
        // clear the query when you're on a different tab. It shouldn't feel jank though.
        if (!search) {
            previousQuery.current = '';
            previousFilters.current = [];
        }
    }, [
        triggerDebounce,
        setTriggerDebounce,
        postQueryItemSupplier,
        sectionIds,
        query,
        analyticsInfo,
        filters,
        isDisplayed,
        workspaces,
        preventDebouncedSearch,
        isPreQueryFiltersEnabled,
        setPostQueryAPIState
    ]);
};
const $2f0fec97faec665d$var$useResetPostQueryItemOnNewSearch = ({ query: query, filters: filters, isDisplayed: isDisplayed, setPostQueryItems: setPostQueryItems, setPostQueryAPIState: setPostQueryAPIState, debouncedSetter: debouncedSetter, sectionIds: sectionIds, preventDebouncedSearch: preventDebouncedSearch, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled })=>{
    // We want to retain the last search query value to avoid an infinite loop of postQueryItemSupplier
    const queryRef = (0, $42omo.useRef)(query);
    const filtersRef = (0, $42omo.useRef)(filters);
    (0, $42omo.useEffect)(()=>{
        if ((queryRef.current !== query || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(filtersRef.current, filters)) && (query || isPreQueryFiltersEnabled && filters.length) && isDisplayed && sectionIds && sectionIds.length > 0) {
            // reset post query items when we start a new search
            setPostQueryItems((0, $8ioQN.EMPTY_SEARCH_ITEMS));
            // If debounced search is prevented we set the state to typing instead of loading
            if (preventDebouncedSearch) // Typing state means that we don't fire the supplier on debounce and the user types their query
            setPostQueryAPIState((0, $jFPud.APIStates).Typing);
            else setPostQueryAPIState((0, $jFPud.APIStates).Loading);
            debouncedSetter();
        }
        queryRef.current = query;
        filtersRef.current = filters;
    }, [
        query,
        isDisplayed,
        sectionIds,
        setPostQueryItems,
        setPostQueryAPIState,
        debouncedSetter,
        queryRef,
        filters,
        filtersRef,
        preventDebouncedSearch,
        isPreQueryFiltersEnabled
    ]);
};
const $2f0fec97faec665d$var$useResetPostQueryAPIStateOnEmptySearch = ({ query: query, filters: filters, isDisplayed: isDisplayed, setPostQueryAPIState: setPostQueryAPIState, preventDebouncedSearch: preventDebouncedSearch, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled })=>{
    // We want to retain the last search query value to avoid an infinite loop of postQueryItemSupplier
    const queryRef = (0, $42omo.useRef)(query);
    const filtersRef = (0, $42omo.useRef)(filters);
    (0, $42omo.useEffect)(()=>{
        // These two checks both assume query === '' so it's checked independanctly in the if condition below
        const queryRemoved = queryRef.current !== '' && (!isPreQueryFiltersEnabled || filters.length === 0);
        const filtersRemoved = isPreQueryFiltersEnabled && filters.length === 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(filtersRef.current, []);
        // If the user returns to the pre-query state by removing the query or by clearing the filters when there isn't a query
        if (isDisplayed && query === '' && (queryRemoved || filtersRemoved)) {
            // Reset the post query api state to typing if debounced search is off, and loading is debounced search is on
            if (preventDebouncedSearch) setPostQueryAPIState((0, $jFPud.APIStates).Typing);
            else setPostQueryAPIState((0, $jFPud.APIStates).Loading);
        }
        queryRef.current = query;
        filtersRef.current = filters;
    }, [
        query,
        isDisplayed,
        setPostQueryAPIState,
        queryRef,
        filtersRef,
        preventDebouncedSearch,
        filters,
        isPreQueryFiltersEnabled
    ]);
};
const $2f0fec97faec665d$export$6c8a9648ef625887 = ({ filters: filters, isPrefetchingEnabled: isPrefetchingEnabled, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled, sectionIds: sectionIds, preQueryItemSupplier: preQueryItemSupplier, isDisplayed: isDisplayed, workspaces: workspaces })=>{
    /**
	 * Even in case of cache warming we want to track the product state hence we should always pass the decorated supplier. Note: Both decorated and non decorated suppliers have the same signature.
	 */ (0, $42omo.useEffect)(()=>{
        if ((!isPreQueryFiltersEnabled || filters.length === 0) && (isPrefetchingEnabled === true || isDisplayed === true) && sectionIds && sectionIds.length > 0) preQueryItemSupplier({
            sectionIds: sectionIds,
            workspaces: workspaces
        }).catch((ignore)=>{});
    }, [
        isPrefetchingEnabled,
        isPreQueryFiltersEnabled,
        isDisplayed,
        sectionIds,
        preQueryItemSupplier,
        workspaces,
        filters.length
    ]);
};
const $2f0fec97faec665d$export$1611a8309e261165 = ({ preQueryItemSupplier: preQueryItemSupplier, onRetry: onRetry, sectionIds: sectionIds, workspaces: workspaces })=>{
    return (0, $42omo.useCallback)(()=>{
        preQueryItemSupplier({
            sectionIds: sectionIds,
            workspaces: workspaces
        });
        onRetry?.();
    }, [
        onRetry,
        preQueryItemSupplier,
        sectionIds,
        workspaces
    ]);
};
const $2f0fec97faec665d$export$def67f037e925145 = ({ postQueryItemSupplier: postQueryItemSupplier, onRetry: onRetry, query: query, analyticsInfo: analyticsInfo, filters: filters, sectionIds: sectionIds, workspaces: workspaces })=>{
    return (0, $42omo.useCallback)(()=>{
        postQueryItemSupplier({
            query: query,
            analyticsInfo: analyticsInfo,
            sectionIds: sectionIds,
            filters: filters,
            workspaces: workspaces
        });
        onRetry?.();
    }, [
        postQueryItemSupplier,
        query,
        analyticsInfo,
        sectionIds,
        filters,
        workspaces,
        onRetry
    ]);
};
const $2f0fec97faec665d$export$e8aa10fa5cd147e8 = ({ id: id, debounceTime: debounceTime, query: query, analyticsInfo: analyticsInfo, filters: filters, isPrefetchingEnabled: isPrefetchingEnabled, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled, workspaces: workspaces, onRetry: onRetry, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, setPostQueryItems: setPostQueryItems, setPostQueryAPIState: setPostQueryAPIState })=>{
    const { getProduct: getProduct } = (0, $fJRVo.useProductContext)();
    const product = getProduct(id);
    const isDisplayed = product?.isDisplayed || false;
    const sectionIds = (0, $42omo.useMemo)(()=>product?.sectionIds || [], [
        product
    ]);
    const preventDebouncedSearch = !!product?.showSearchOnEnter;
    const invokePostQuerySearchRef = product?.invokePostQuerySearchRef;
    const invokePostQueryItemSupplier = (0, $42omo.useCallback)(()=>{
        postQueryItemSupplier({
            query: query,
            filters: filters,
            analyticsInfo: analyticsInfo,
            sectionIds: sectionIds,
            workspaces: workspaces
        }).catch((ignore)=>{});
    }, [
        analyticsInfo,
        filters,
        postQueryItemSupplier,
        query,
        sectionIds,
        workspaces
    ]);
    if (invokePostQuerySearchRef) invokePostQuerySearchRef.current = invokePostQueryItemSupplier;
    $2f0fec97faec665d$export$4dd234b8f57e873a({
        isDisplayed: isDisplayed,
        debounceTime: debounceTime,
        postQueryItemSupplier: postQueryItemSupplier,
        query: query,
        analyticsInfo: analyticsInfo,
        filters: filters,
        sectionIds: sectionIds,
        setPostQueryItems: setPostQueryItems,
        setPostQueryAPIState: setPostQueryAPIState,
        workspaces: workspaces,
        preventDebouncedSearch: !!preventDebouncedSearch,
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled
    });
    $2f0fec97faec665d$export$6c8a9648ef625887({
        isDisplayed: isDisplayed,
        preQueryItemSupplier: preQueryItemSupplier,
        filters: filters,
        sectionIds: sectionIds,
        isPrefetchingEnabled: isPrefetchingEnabled,
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
        workspaces: workspaces
    });
    const updateStateOnRetryPreQuery = $2f0fec97faec665d$export$1611a8309e261165({
        preQueryItemSupplier: preQueryItemSupplier,
        onRetry: onRetry,
        sectionIds: sectionIds,
        isDisplayed: isDisplayed,
        workspaces: workspaces
    });
    const updateStateOnRetryPostQuery = $2f0fec97faec665d$export$def67f037e925145({
        postQueryItemSupplier: postQueryItemSupplier,
        onRetry: onRetry,
        query: query,
        analyticsInfo: analyticsInfo,
        filters: filters,
        sectionIds: sectionIds,
        isDisplayed: isDisplayed,
        workspaces: workspaces
    });
    return {
        onRetryPreQuery: updateStateOnRetryPreQuery,
        onRetryPostQuery: updateStateOnRetryPostQuery
    };
};






var $48BnN = parcelRequire("48BnN");


var $4ldrV = parcelRequire("4ldrV");


var $amrMu = parcelRequire("amrMu");

const $ed804cc173508de4$export$17c235c9629b75d5 = {
    preQuery: {
        [(0, $jFPud.APIStates).Typing]: (0, $jFPud.ProductStates).Invalid,
        [(0, $jFPud.APIStates).Error]: (0, $jFPud.ProductStates).PreQueryError,
        [(0, $jFPud.APIStates).Loading]: (0, $jFPud.ProductStates).PreQueryLoading,
        [(0, $jFPud.APIStates).NoResult]: (0, $jFPud.ProductStates).PreQueryNoResult,
        [(0, $jFPud.APIStates).Success]: (0, $jFPud.ProductStates).PreQuerySuccess
    },
    postQuery: {
        [(0, $jFPud.APIStates).Typing]: (0, $jFPud.ProductStates).PostQueryTyping,
        [(0, $jFPud.APIStates).Error]: (0, $jFPud.ProductStates).PostQueryError,
        [(0, $jFPud.APIStates).Loading]: (0, $jFPud.ProductStates).PostQueryLoading,
        [(0, $jFPud.APIStates).NoResult]: (0, $jFPud.ProductStates).PostQueryNoResult,
        [(0, $jFPud.APIStates).Success]: (0, $jFPud.ProductStates).PostQuerySuccess
    }
};
const $ed804cc173508de4$export$27cbbc9f57a9e765 = ({ setPreQueryItems: setPreQueryItems, setPostQueryItems: setPostQueryItems, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, id: id, isPrefetchingEnabled: isPrefetchingEnabled = false, debounceTime: debounceTime = 250, onRetry: onRetry, workspaces: workspaces, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled = false })=>{
    const { query: query, queryVersion: queryVersion } = (0, $2ZIpG.useQuery)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const appliedFilters = (0, $48BnN.useAppliedFilters)(id);
    const features = (0, $amrMu.useFeaturesContext)();
    /**
	 * We track the API calls of Post and Pre query separately.
	 */ const [preQueryAPIState, setPreQueryAPIState] = (0, $42omo.useState)((0, $jFPud.APIStates).Loading);
    const [postQueryAPIState, setPostQueryAPIState] = (0, $42omo.useState)((0, $jFPud.APIStates).Loading);
    const decoratedPreQuerySupplier = (0, $c008c398b65e94aa$export$1a0b61dc15626973)({
        setAPIState: setPreQueryAPIState,
        preQueryItemSupplier: preQueryItemSupplier,
        setState: setPreQueryItems,
        id: id
    });
    const decoratedPostQuerySupplier = (0, $078777d7fdf49344$export$c89ff2b708144e3c)({
        setAPIState: setPostQueryAPIState,
        setState: setPostQueryItems,
        postQueryItemSupplier: postQueryItemSupplier,
        debounceTime: debounceTime,
        id: id
    });
    const { onRetryPreQuery: updateStateOnRetryPreQuery, onRetryPostQuery: updateStateOnRetryPostQuery } = (0, $2f0fec97faec665d$export$e8aa10fa5cd147e8)({
        id: id,
        query: query,
        analyticsInfo: {
            queryVersion: queryVersion,
            searchSessionId: searchSessionId
        },
        filters: appliedFilters,
        isPrefetchingEnabled: isPrefetchingEnabled,
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
        preQueryItemSupplier: decoratedPreQuerySupplier,
        postQueryItemSupplier: decoratedPostQuerySupplier,
        debounceTime: debounceTime,
        setPostQueryItems: setPostQueryItems,
        onRetry: onRetry,
        setPostQueryAPIState: setPostQueryAPIState,
        workspaces: workspaces
    });
    let state;
    if ((query !== '' || isPreQueryFiltersEnabled && appliedFilters.length) && !features?.quickFind?.postQueryDisabled) state = $ed804cc173508de4$export$17c235c9629b75d5.postQuery[postQueryAPIState];
    else state = $ed804cc173508de4$export$17c235c9629b75d5.preQuery[preQueryAPIState];
    return {
        state: state,
        onRetryPreQuery: updateStateOnRetryPreQuery,
        onRetryPostQuery: updateStateOnRetryPostQuery
    };
};



var $bBxPo = parcelRequire("bBxPo");








var $2LczZ = parcelRequire("2LczZ");





var $2jYn8 = parcelRequire("2jYn8");





var $kUZlH = parcelRequire("kUZlH");


var $bF0iL = parcelRequire("bF0iL");





var $3cM77 = parcelRequire("3cM77");


var $7OZuO = parcelRequire("7OZuO");


var $ctiC5 = parcelRequire("ctiC5");





var $4Lm6U = parcelRequire("4Lm6U");










const $b7beb5bdf3ce4c5d$export$b7b07b85de5702d4 = ({ retainHeight: retainHeight, children: children, ...rest })=>{
    const minimumHeight = (0, $42omo.useRef)(undefined);
    const ref = (0, $42omo.useRef)(null);
    // Why is this not in a `useEffect`?
    // Render order for React is from top down (parent -> children), this enables to retain the most up to date height of the children before a transition happens.
    // useEffect happens after render so we won't be able to account for changes to child height that does not cause a render to this component, checking the height
    // when the transition happens would be too late as it will register the new height instead.
    if (retainHeight) {
        const height = ref.current?.getBoundingClientRect()?.height;
        minimumHeight.current = height;
    }
    // Despite what is said above we do need to track the initial size, this can only be done once the ref.current? is set hence the onMount useEffect here.
    (0, $42omo.useEffect)(()=>{
        const height = ref.current?.getBoundingClientRect()?.height;
        minimumHeight.current = height;
    }, []);
    const shouldFixMinimumHeight = retainHeight && minimumHeight.current;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.ResultRenderWrapper), {
        shouldFixMinimumHeight: shouldFixMinimumHeight,
        minimumHeight: minimumHeight.current,
        ref: ref,
        ...rest,
        children: children
    });
};



var $bKrl4 = parcelRequire("bKrl4");











var $88j1D = parcelRequire("88j1D");

















var $igBZP = parcelRequire("igBZP");


var $1cfRh = parcelRequire("1cfRh");


var $esRft = parcelRequire("esRft");


var $WWFoj = parcelRequire("WWFoj");


var $lggDm = parcelRequire("lggDm");








var $eEA8O = parcelRequire("eEA8O");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

function $d1a01ca2192f5c5d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d1a01ca2192f5c5d$export$2b188a2db2e1eabb = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e132hrf52"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $2azjJ.grid).half().px} 0 0 -${(0, $2azjJ.grid).px}`
});
const $d1a01ca2192f5c5d$export$524ab404a46fe64d = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e132hrf51"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $2azjJ.grid).half().px} 0`
});
const $d1a01ca2192f5c5d$export$749e0fb71c21003 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e132hrf50"
})({
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
});


class $b722acb16295b16d$export$53b1613b48d79692 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentWillUnmount() {
        this.focusTimeout && clearTimeout(this.focusTimeout);
    }
    renderEditView() {
        const FilterComponent = this.props.filterComponent;
        return /*#__PURE__*/ (0, $l998X.jsx)(FilterComponent, {
            defaultOptions: this.props.defaultOptions,
            loadOptions: this.props.loadOptions,
            placeholderText: this.props.placeholderText,
            label: this.props.placeholderText,
            onConfirm: this.onConfirm,
            onMenuClosed: ()=>{
                this.setIsEdit(false);
            },
            refocusEditLink: this.refocusEditLink,
            loadingMessage: this.props.loadingMessage,
            noOptionsMessage: this.props.noOptionsMessage,
            onFocusAriaMessage: this.props.onFocusAriaMessage
        });
    }
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $d1a01ca2192f5c5d$export$2b188a2db2e1eabb), {
            children: this.state.isEdit ? this.renderEditView() : this.renderReadView()
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isEdit: false
        };
        this.focusTimeout = void 0;
        this.readViewRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.setIsEdit = (isEdit)=>{
            this.setState({
                isEdit: isEdit
            });
        };
        this.refocusEditLink = ()=>this.focusTimeout = setTimeout(()=>this.readViewRef.current?.focus(), 0);
        this.onConfirm = (value)=>{
            this.refocusEditLink();
            return this.props.addFilter(value);
        };
        this.renderReadView = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $d1a01ca2192f5c5d$export$524ab404a46fe64d), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                    ref: this.readViewRef,
                    appearance: "link",
                    onClick: ()=>this.setIsEdit(true),
                    "aria-label": this.props.buttonLabel,
                    isDisabled: this.props.isDisabled,
                    children: this.props.buttonText
                })
            });
    }
}



var $h2kng = parcelRequire("h2kng");







function $a9d471a053f2d804$var$isOptionType(o) {
    return o.value !== undefined;
}

const $a9d471a053f2d804$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("4Scw6")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $a9d471a053f2d804$export$15e0a6dd776b6e98 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { menuIsOpen: menuIsOpen, inputValue: inputValue } = this.state;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)($a9d471a053f2d804$var$AsyncSelect, {
                defaultOptions: this.props.defaultOptions,
                loadOptions: this.props.loadOptions,
                autoFocus: true,
                openMenuOnFocus: true,
                ariaLiveMessages: this.props.onFocusAriaMessage ? {
                    onFocus: this.props.onFocusAriaMessage
                } : undefined,
                inputValue: inputValue,
                menuIsOpen: menuIsOpen,
                placeholder: this.props.placeholderText,
                loadingMessage: this.props.loadingMessage,
                noOptionsMessage: this.props.noOptionsMessage,
                onChange: this.onChange,
                onKeyDown: (e)=>{
                    if (e.key === 'Escape') {
                        this.props.onMenuClosed();
                        e.stopPropagation();
                        this.props.refocusEditLink();
                    }
                },
                onBlur: ()=>{
                    this.props.refocusEditLink();
                    this.props.onMenuClosed();
                },
                onFocus: this.handleFocus,
                menuPosition: "fixed",
                captureMenuScroll: true,
                onInputChange: this.handleInputChange
            })
        });
    }
    constructor(props){
        super(props);
        this.onChange = (value, { action: action })=>{
            if ($a9d471a053f2d804$var$isOptionType(value) && (action === 'select-option' || action === 'create-option')) {
                this.props.onMenuClosed();
                this.props.refocusEditLink();
                this.props.onConfirm(value);
            }
        };
        this.handleFocus = ()=>{
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleInputChange = (query, { action: action })=>{
            const { inputValue: inputValue } = this.state;
            if (action === 'input-change' || action === 'set-value') {
                this.setState({
                    inputValue: query
                });
                return query;
            }
            if (action === 'menu-close') {
                // want to keep menu open if user clicks on input box
                this.setState({
                    menuIsOpen: true,
                    inputValue: inputValue
                });
                // need to return inputValue to override react-select resetting
                // to empty string and clearing options if user clicks on input box
                return inputValue;
            }
        };
        this.state = {
            menuIsOpen: false,
            inputValue: ''
        };
    }
}
var $a9d471a053f2d804$export$2e2bcd8739ae039 = $a9d471a053f2d804$export$15e0a6dd776b6e98;



var $169DF = parcelRequire("169DF");








var $dIZm4 = parcelRequire("dIZm4");





var $hUj82 = parcelRequire("hUj82");

const $77354ef4a5de03b5$var$SHOW_MORE_DEBOUNCE_TIME = 250;
const $77354ef4a5de03b5$export$bbc3e0c0bbb663f0 = ({ filterType: filterType, store: store, loadFilterOptions: loadFilterOptions, sectionLabel: sectionLabel, findMoreLabel: findMoreLabel, maxSelectable: maxSelectable, filterConfig: filterConfig })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { availableFilters: availableFilters, updateFilter: updateFilter, addFilters: addFilters, isLoading: isLoading } = store;
    const usePreloadedOptions = filterConfig?.usePreloadedOptions || false;
    const showIcons = !filterConfig?.hideIcon;
    const appearanceIcon = filterConfig?.filterOptionIconShape || 'square';
    const options = availableFilters.map((filterOption)=>({
            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $hUj82.FilterOptionItem), {
                label: filterOption.label,
                iconProps: {
                    src: filterOption.avatarUrl,
                    appearance: filterConfig?.filterOptionIconShape
                }
            }),
            value: filterOption
        }));
    const visibleOptions = options.filter((option)=>option.value.isVisible);
    const onChangeCallback = (0, $42omo.useCallback)((value, _, checked)=>{
        updateFilter(value, checked);
    }, [
        updateFilter
    ]);
    const addFilter = (0, $42omo.useCallback)(({ value: value })=>{
        addFilters([
            value
        ]);
        updateFilter(value.id, true);
        fireAnalyticsEvent((0, $5dFS9.onFilterSelect)({
            filterId: value.id,
            filterSource: (0, $169DF.FilterOptionSource).EXTERNAL,
            filterType: filterType
        }));
    }, [
        addFilters,
        updateFilter,
        fireAnalyticsEvent,
        filterType
    ]);
    const loadMoreFilters = (0, (/*@__PURE__*/$parcel$interopDefault($igBZP)))((query)=>loadFilterOptions(query), $77354ef4a5de03b5$var$SHOW_MORE_DEBOUNCE_TIME);
    const loadAvatar = (0, $42omo.useCallback)(({ avatarUrl: iconUrl, name: name })=>{
        if (showIcons) return /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearanceIcon,
            size: 'small',
            name: name
        });
    }, [
        showIcons,
        appearanceIcon
    ]);
    const checkedValues = availableFilters.filter((filter)=>filter.isChecked);
    const showMoreOptions = options.filter((option)=>!option.value.isVisible);
    const filterPreloadedOptions = (query)=>Promise.resolve(showMoreOptions.filter((option)=>option.value.label.indexOf(query.trim().toLowerCase()) !== -1));
    const isMaxValuesSelected = !!maxSelectable && checkedValues.length === maxSelectable;
    const loadFilterItems = (isColumnGrouped = false)=>visibleOptions.map(({ value: value })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dIZm4.ProductFilterItem), {
                value: value.id,
                filterType: filterType,
                icon: loadAvatar(value),
                label: value.label,
                onChange: onChangeCallback,
                isChecked: value.isChecked,
                filterSource: value.filterSource,
                isDisabled: isMaxValuesSelected && !value.isChecked,
                variant: (0, $h2kng.OptionVariant).CHECKBOX,
                LabelComponent: filterConfig?.labelComponent ?? (isColumnGrouped ? (0, $lggDm.FilterColLabelText) : (0, $lggDm.FilterRowLabelText))
            }));
    const onFocusAriaMessage = (0, $42omo.useCallback)((props)=>{
        const { focused: focused, options: options } = props;
        const optionIndex = options?.findIndex((option)=>{
            return option === focused;
        });
        return `Option ${focused.value.label} focused, ${optionIndex + 1} out of ${options.length}.`;
    }, []);
    const loadFilterShowMore = ()=>!(usePreloadedOptions && showMoreOptions.length === 0) && /*#__PURE__*/ (0, $l998X.jsx)((0, $b722acb16295b16d$export$53b1613b48d79692), {
            placeholderText: findMoreLabel,
            addFilter: addFilter,
            defaultOptions: showMoreOptions || [],
            loadOptions: usePreloadedOptions ? filterPreloadedOptions : loadMoreFilters,
            buttonLabel: findMoreLabel,
            buttonText: formatMessage((0, $bF0iL.messages).show_more_filters),
            filterComponent: (0, $a9d471a053f2d804$export$15e0a6dd776b6e98),
            loadingMessage: ()=>formatMessage((0, $bF0iL.messages).loading_filters),
            noOptionsMessage: ()=>formatMessage((0, $bF0iL.messages).no_options_filters),
            isDisabled: isMaxValuesSelected,
            onFocusAriaMessage: onFocusAriaMessage
        });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            (!filterConfig?.filterGroupedBy || filterConfig?.filterGroupedBy === 'column') && /*#__PURE__*/ (0, $l998X.jsxs)((0, $WWFoj.ColumnFilterGroup), {
                title: sectionLabel,
                isLoading: isLoading,
                avatarShape: filterConfig?.filterOptionIconShape ?? 'circle',
                children: [
                    loadFilterItems(true),
                    loadFilterShowMore()
                ]
            }),
            filterConfig?.filterGroupedBy === 'row' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $WWFoj.RowFilterGroup), {
                title: sectionLabel,
                isLoading: false,
                children: [
                    loadFilterItems(false),
                    loadFilterShowMore()
                ]
            })
        ]
    });
};









var $h2sba = parcelRequire("h2sba");


const $f788e745cbc15b8e$var$AsyncFeedbackCollector = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("kiEGX"))));
const $f788e745cbc15b8e$var$ExtensibleFeedbackCollector = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $h2sba.FeedbackButton), {
            onClick: ()=>{}
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($f788e745cbc15b8e$var$AsyncFeedbackCollector, {})
    });
};
var $f788e745cbc15b8e$export$2e2bcd8739ae039 = $f788e745cbc15b8e$var$ExtensibleFeedbackCollector;












var $hiS1z = parcelRequire("hiS1z");


var $kPBHE = parcelRequire("kPBHE");




function $2f04cb7862e773d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f04cb7862e773d7$export$c592d0ff434e3f = /*#__PURE__*/ (0, $cStGJ.default)((0, $kPBHE.Link), {
    target: "e3by6ib1"
})({
    name: "ojsxl9",
    styles: "display:block;text-align:center;border-radius:var(--ds-radius-small, 3px);color:var(--ds-text-subtle, #505258);cursor:pointer;padding:var(--ds-space-075, 6px);background-color:var(--ds-background-neutral, #0515240F);transition:background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);&:hover{color:var(--ds-text-subtle, #505258);background-color:var(--ds-background-neutral-hovered, #0B120E24);text-decoration:none;transition:background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);}&:visited{color:var(--ds-text-subtle, #505258);}"
});
const $2f04cb7862e773d7$export$5a1c3f665eb7c630 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e3by6ib0"
})({
    name: "1y04g5d",
    styles: "padding-top:var(--ds-space-400, 32px)"
});



var $3S0fp = parcelRequire("3S0fp");










const $210f493dbb7006b9$var$MoreFilters = ({ linkComponent: linkComponent, href: href, selectedFiltersCount: selectedFiltersCount, isLoading: isLoading, onClick: onClick, ...rest })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onMoreFiltersClicked = (0, $42omo.useCallback)((event)=>{
        const trigger = (0, $3S0fp.getTrigger)(event);
        onClick?.();
        fireAnalyticsEvent((0, $5dFS9.onMoreFiltersSelected)({
            trigger: trigger,
            selectedFiltersCount: selectedFiltersCount
        }));
    }, [
        fireAnalyticsEvent,
        selectedFiltersCount,
        onClick
    ]);
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2f04cb7862e773d7$export$c592d0ff434e3f), {
        ...rest,
        linkComponent: linkComponent,
        href: href,
        onClick: onMoreFiltersClicked,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...(0, $bF0iL.messages).more_filters
        })
    });
};
var $210f493dbb7006b9$export$2e2bcd8739ae039 = $210f493dbb7006b9$var$MoreFilters;



var $80L9g = parcelRequire("80L9g");



const $235b7a449e9fd2ef$var$StaticSelectFilter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("yVFeO")).then(({ StaticSelectFilter: StaticSelectFilter })=>({
            default: StaticSelectFilter
        })));

const $235b7a449e9fd2ef$var$MultiSelectFilter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("fx9gO")).then(({ MultiSelectFilter: MultiSelectFilter })=>({
            default: MultiSelectFilter
        })));
const $235b7a449e9fd2ef$export$58cd6790f867654e = 5;
const $235b7a449e9fd2ef$var$Filters = ({ query: query, filters: filters, href: href, showViewAllFiltersLink: showViewAllFiltersLink })=>{
    const { resetSearchSession: resetSearchSession } = (0, $80L9g.useSessionUserInput)();
    const selectedFiltersCount = (0, $lfOhG.useCurrentProductGenericSelectedFilterCount)();
    const siteFilters = filters.find((filter)=>filter['@type'] === (0, $88j1D.SITE_FILTER_TYPE_NAME));
    if (!!siteFilters) siteFilters.filterConfig = {
        ...siteFilters.filterConfig,
        hideIcon: true,
        usePreloadedOptions: true
    };
    const nonSiteFilters = filters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME));
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.SidebarContainerBorder), {}),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $2LczZ.SidebarContainerPane), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $2LczZ.SidebarScrollContainer), {
                            children: [
                                !!siteFilters && /*#__PURE__*/ (0, $l998X.jsx)((0, $77354ef4a5de03b5$export$bbc3e0c0bbb663f0), {
                                    filterType: siteFilters['@type'],
                                    ...siteFilters,
                                    maxSelectable: $235b7a449e9fd2ef$export$58cd6790f867654e
                                }),
                                nonSiteFilters.map((nonSiteFilter)=>{
                                    switch(nonSiteFilter.uiVariant){
                                        case (0, $88j1D.FilterUIVariant).MULTI_SELECT:
                                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                                fallback: null,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)($235b7a449e9fd2ef$var$MultiSelectFilter, {
                                                    filterType: nonSiteFilter['@type'],
                                                    ...nonSiteFilter
                                                })
                                            });
                                        case (0, $88j1D.FilterUIVariant).STATIC_SELECT:
                                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                                fallback: null,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)($235b7a449e9fd2ef$var$StaticSelectFilter, {
                                                    filterType: nonSiteFilter['@type'],
                                                    filterStore: nonSiteFilter.store,
                                                    sectionTitle: nonSiteFilter.sectionLabel
                                                })
                                            });
                                        default:
                                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $77354ef4a5de03b5$export$bbc3e0c0bbb663f0), {
                                                filterType: nonSiteFilter['@type'],
                                                ...nonSiteFilter
                                            });
                                    }
                                }),
                                !siteFilters && showViewAllFiltersLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $2f04cb7862e773d7$export$5a1c3f665eb7c630), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $210f493dbb7006b9$export$2e2bcd8739ae039), {
                                        isLoading: false,
                                        href: href,
                                        query: query,
                                        selectedFiltersCount: selectedFiltersCount,
                                        onClick: resetSearchSession
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.SidebarBottomFixedContainer), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f788e745cbc15b8e$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        }), [
        href,
        nonSiteFilters,
        query,
        resetSearchSession,
        selectedFiltersCount,
        showViewAllFiltersLink,
        siteFilters
    ]);
};
const $235b7a449e9fd2ef$export$4c5b17bfcbab1742 = ({ productState: productState, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled = false })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const productId = activeProduct?.id;
    const filters = (0, $lfOhG.useGetCurrentProductFilters)();
    if (!productId || !filters.length) return null;
    const href = activeProduct?.generateAdvancedSearchUrl?.(query) || '';
    const showViewAllFiltersLink = !!activeProduct?.showViewAllFiltersLink;
    switch(productState){
        case (0, $jFPud.ProductStates).PostQueryTyping:
        case (0, $jFPud.ProductStates).PostQueryLoading:
        case (0, $jFPud.ProductStates).PostQuerySuccess:
        case (0, $jFPud.ProductStates).PostQueryNoResult:
        case (0, $jFPud.ProductStates).PostQueryError:
            return /*#__PURE__*/ (0, $l998X.jsx)($235b7a449e9fd2ef$var$Filters, {
                query: query,
                filters: filters,
                href: href,
                showViewAllFiltersLink: showViewAllFiltersLink
            });
        case (0, $jFPud.ProductStates).Invalid:
            return null;
        default:
            if (isPreQueryFiltersEnabled) return /*#__PURE__*/ (0, $l998X.jsx)($235b7a449e9fd2ef$var$Filters, {
                query: query,
                filters: filters,
                href: href,
                showViewAllFiltersLink: showViewAllFiltersLink
            });
            return null;
    }
};



var $hKdD9 = parcelRequire("hKdD9");


var $5TmpD = parcelRequire("5TmpD");


var $kPY5t = parcelRequire("kPY5t");





var $eztGN = parcelRequire("eztGN");




const $20cee92809fd62b0$export$464b81a1c23b01aa = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', preQuerySectionTitleGenerator: preQuerySectionTitleGenerator, linkComponent: linkComponent, children: children, searchFooterLabel: searchFooterLabel, appendQueryParams: appendQueryParams, isPreQueryFiltersEnabled: isPreQueryFiltersEnabled })=>{
    const DefaultHeader = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    const DefaultSectionFooter = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    const isMobileView = (0, $kPY5t.useIsMobileView)();
    const areFiltersEnabled = (0, $lfOhG.useCurrentProductHasFilters)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $5TmpD.useAutocorrectionEnabled)();
    const { correction: correction } = (0, $hKdD9.useAutocorrection)();
    const renderer = children && typeof children === 'function' ? children({
        query: query,
        productState: productState,
        linkComponent: linkComponent,
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItems,
        onRetryPreQuery: onRetryPreQuery,
        onRetryPostQuery: onRetryPostQuery,
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    }) : null;
    const Header = renderer?.Header || DefaultHeader;
    const SectionFooter = renderer?.SectionFooter || DefaultSectionFooter;
    const Footer = renderer?.Footer || /*#__PURE__*/ (0, $l998X.jsx)((0, $bKrl4.GetDefaultFooter), {
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        linkComponent: linkComponent,
        productState: productState,
        searchFooterLabel: searchFooterLabel
    });
    const renderResults = (0, $42omo.useCallback)(()=>{
        switch(productState){
            case (0, $jFPud.ProductStates).PostQueryError:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $4Lm6U.SearchErrorScreen), {
                    onRetry: onRetryPostQuery
                });
            case (0, $jFPud.ProductStates).PostQueryTyping:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    screen: "cachedResults",
                    forceHideResultCount: true,
                    linkComponent: linkComponent,
                    isCollapsed: areFiltersEnabled || isMobileView,
                    productState: (0, $jFPud.ProductStates).PostQueryTyping,
                    appendQueryParams: appendQueryParams
                });
            case (0, $jFPud.ProductStates).PostQueryLoading:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    screen: "cachedResults",
                    forceHideResultCount: true,
                    linkComponent: linkComponent,
                    isCollapsed: areFiltersEnabled || isMobileView,
                    productState: (0, $jFPud.ProductStates).PostQueryLoading,
                    appendQueryParams: appendQueryParams,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2jYn8.LoadingSpinner), {})
                });
            case (0, $jFPud.ProductStates).PostQueryNoResult:
                return (0, $2jE99.hasSearchResults)(postQueryItems) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    screen: "cachedResults",
                    forceHideResultCount: true,
                    linkComponent: linkComponent,
                    isCollapsed: areFiltersEnabled || isMobileView,
                    productState: (0, $jFPud.ProductStates).PostQueryLoading,
                    appendQueryParams: appendQueryParams
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $7OZuO.default), {
                    urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen
                });
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                        searchItems: postQueryItems,
                        forceHideResultCount: autocorrectionEnabled && !!correction && correction.length > 0,
                        linkComponent: linkComponent,
                        screen: "postQuerySearchResults",
                        productState: (0, $jFPud.ProductStates).PostQuerySuccess,
                        isCollapsed: areFiltersEnabled || isMobileView,
                        renderSectionViewAll: true,
                        appendQueryParams: appendQueryParams
                    })
                });
            case (0, $jFPud.ProductStates).PreQueryError:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ctiC5.default), {});
            case (0, $jFPud.ProductStates).PreQueryLoading:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $2jYn8.LoadingSpinner), {});
            case (0, $jFPud.ProductStates).PreQueryNoResult:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $3cM77.default), {});
            case (0, $jFPud.ProductStates).PreQuerySuccess:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: preQueryItems,
                    generateSectionTitle: (section, intl)=>{
                        return preQuerySectionTitleGenerator?.(section) || intl.formatMessage((0, $bF0iL.messages).recently_viewed_title, {
                            sectionTitle: section.title
                        });
                    },
                    linkComponent: linkComponent,
                    screen: "preQuerySearchResults",
                    forceHideResultCount: true,
                    productState: (0, $jFPud.ProductStates).PreQuerySuccess,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
        }
    }, [
        correction,
        autocorrectionEnabled,
        productState,
        preQueryItems,
        postQueryItems,
        linkComponent,
        onRetryPostQuery,
        preQuerySectionTitleGenerator,
        urlGeneratorForNoResultsScreen,
        areFiltersEnabled,
        isMobileView,
        appendQueryParams
    ]);
    const body = (0, $42omo.useMemo)(()=>renderer && renderer.Body && renderer?.Body() !== undefined ? renderer.Body : renderResults, [
        renderer,
        renderResults
    ]);
    const isOnLoadingScreen = productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PreQueryLoading;
    const footer = typeof Footer === 'function' ? /*#__PURE__*/ (0, $l998X.jsx)(Footer, {}) : Footer;
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const showAtlassianHomeSearchLink = (0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $b7beb5bdf3ce4c5d$export$b7b07b85de5702d4), {
        retainHeight: isOnLoadingScreen,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(Header, {}),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $2LczZ.SearchDialogContent), {
                showAtlassianHomeSearchLink: showAtlassianHomeSearchLink,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $2LczZ.ResultContainerOuter), {
                        "aria-live": "polite",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2LczZ.ResultContainer), {
                                children: body()
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)(SectionFooter, {})
                        ]
                    }),
                    areFiltersEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $235b7a449e9fd2ef$export$4c5b17bfcbab1742), {
                        productState: productState,
                        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled
                    })
                ]
            }),
            footer
        ]
    });
};





parcelRequire("42omo");










const $1523c8bfb4e197ec$export$dacde20e096a894f = (productState)=>{
    const { setAdditionalAnalyticsContext: setAdditionalAnalyticsContext } = (0, $2ZIpG.useQuery)();
    (0, $42omo.useEffect)(()=>{
        const isLoading = productState === (0, $jFPud.ProductStates).PreQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryLoading;
        setAdditionalAnalyticsContext({
            type: 'isLoading',
            value: isLoading
        });
    }, [
        productState,
        setAdditionalAnalyticsContext
    ]);
};



const $600488ff5b349843$var$RegisterAnalytics = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, children: children })=>{
    (0, $1523c8bfb4e197ec$export$dacde20e096a894f)(productState);
    (0, $28d34b46d5c2a630$export$4969b75c2e508ab8)(productState, preQueryItems, postQueryItems);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
var $600488ff5b349843$export$2e2bcd8739ae039 = $600488ff5b349843$var$RegisterAnalytics;












var $74Udv = parcelRequire("74Udv");

const $6c0d3bd50fd0ec48$export$1859351207470d7b = ({ postQueryItems: postQueryItems, preQueryItems: preQueryItems, children: children })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const hasFilters = (0, $lfOhG.useCurrentProductHasAppliedFilters)();
    const intermediateItems = (0, $42omo.useMemo)(()=>(0, $74Udv.filterFirstSectionItems)(preQueryItems, query, hasFilters ? 0 : 3), [
        preQueryItems,
        query,
        hasFilters
    ]);
    const resultItems = (0, $42omo.useMemo)(()=>postQueryItems ? (0, $74Udv.mergeFirstSectionSearchItems)(intermediateItems, postQueryItems) : intermediateItems, [
        intermediateItems,
        postQueryItems
    ]);
    const firstSectionResultItems = {
        size: resultItems.size,
        sections: resultItems.sections.length > 0 ? [
            resultItems.sections[0]
        ] : []
    };
    return children({
        searchItems: firstSectionResultItems
    });
};


const $2dc3dd6e54487ea1$var$DefaultSearchItemsTransformer = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, isFasterSearchDisabled: isFasterSearchDisabled, children: children })=>{
    return isFasterSearchDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children({
            preQueryItems: preQueryItems,
            postQueryItems: postQueryItems,
            productState: productState
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6c0d3bd50fd0ec48$export$1859351207470d7b), {
        postQueryItems: postQueryItems,
        preQueryItems: preQueryItems,
        children: ({ searchItems: fasterSearchItems })=>{
            const interleavedItems = {
                sections: [
                    ...fasterSearchItems.sections,
                    ...postQueryItems.sections.slice(1)
                ],
                size: postQueryItems.size
            };
            return children({
                preQueryItems: preQueryItems,
                postQueryItems: interleavedItems,
                productState: productState
            });
        }
    });
};
const $2dc3dd6e54487ea1$export$d334bc60c6e550a0 = ({ id: id, children: children, SearchItemsTransformer: SearchItemsTransformer = $2dc3dd6e54487ea1$var$DefaultSearchItemsTransformer, ResultRenderer: ResultRenderer = (0, $20cee92809fd62b0$export$464b81a1c23b01aa), isFasterSearchDisabled: isFasterSearchDisabled, ...rest })=>{
    const [preQueryItems, setPreQueryItems] = (0, $42omo.useState)((0, $8ioQN.EMPTY_SEARCH_ITEMS));
    const [postQueryItems, setPostQueryItems] = (0, $42omo.useState)((0, $8ioQN.EMPTY_SEARCH_ITEMS));
    const { state: state, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery } = (0, $ed804cc173508de4$export$27cbbc9f57a9e765)({
        id: id,
        setPreQueryItems: setPreQueryItems,
        setPostQueryItems: setPostQueryItems,
        ...rest
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bBxPo.ActiveProduct), {
        id: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)(SearchItemsTransformer, {
            preQueryItems: preQueryItems,
            postQueryItems: postQueryItems,
            productState: state,
            isFasterSearchDisabled: isFasterSearchDisabled,
            children: (args)=>{
                const { preQueryItems: transformedPreQueryItems, postQueryItems: transformedPostQueryItems } = args;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $600488ff5b349843$export$2e2bcd8739ae039), {
                    preQueryItems: transformedPreQueryItems,
                    postQueryItems: transformedPostQueryItems,
                    productState: state,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(ResultRenderer, {
                        ...rest,
                        preQueryItems: transformedPreQueryItems,
                        postQueryItems: transformedPostQueryItems,
                        productState: state,
                        onRetryPreQuery: onRetryPreQuery,
                        onRetryPostQuery: onRetryPostQuery,
                        children: children
                    })
                });
            }
        })
    });
};
const $2dc3dd6e54487ea1$export$2ff0d34ee09e527 = ({ children: children, isPrefetchingEnabled: isPrefetchingEnabled, preQueryItemSupplier: preQueryItemSupplier })=>{
    (0, $42omo.useEffect)(()=>{
        if (isPrefetchingEnabled) preQueryItemSupplier({
            sectionIds: []
        }); // legacy products like jira and confluence dont use extensible way of rendering results.
    }, [
        isPrefetchingEnabled,
        preQueryItemSupplier
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
const $2dc3dd6e54487ea1$export$45ebaffba4f546f2 = ({ children: children, id: id, PLS_DONT_USE_skipDefaultStateManagement: PLS_DONT_USE_skipDefaultStateManagement, ...rest })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: !PLS_DONT_USE_skipDefaultStateManagement ? /*#__PURE__*/ (0, $l998X.jsx)($2dc3dd6e54487ea1$export$d334bc60c6e550a0, {
            id: id,
            ...rest,
            children: children
        }) : /*#__PURE__*/ (0, $l998X.jsx)($2dc3dd6e54487ea1$export$2ff0d34ee09e527, {
            isPrefetchingEnabled: rest.isPrefetchingEnabled,
            preQueryItemSupplier: rest.preQueryItemSupplier,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bBxPo.ActiveProduct), {
                id: id,
                children: /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? children : null
            })
        })
    });
};
module.exports["ResultProvider"] = $2dc3dd6e54487ea1$export$45ebaffba4f546f2;

});

parcelRegister("ctiC5", function(module, exports) {
$parcel$export(module.exports, "default", () => $100a2b8246daedcb$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $a7YLG = parcelRequire("a7YLG");


var $cs1vW = parcelRequire("cs1vW");


var $bF0iL = parcelRequire("bF0iL");


const $100a2b8246daedcb$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("cjygl")));
const $100a2b8246daedcb$var$PreQueryErrorScreen = ({ intl: intl })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $a7YLG.EmptyState), {
        title: intl.formatMessage((0, $bF0iL.messages).common_error_state_prequery_heading),
        Image: $100a2b8246daedcb$var$Image
    });
var $100a2b8246daedcb$export$2e2bcd8739ae039 = (0, $cs1vW.default)($100a2b8246daedcb$var$PreQueryErrorScreen);

});

parcelRegister("cjygl", function(module, exports) {

let $8f71d637f05fc836$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f71d637f05fc836$var$load("hHoTx").then(()=>parcelRequire('fjEP3'));

});

parcelRegister("WWFoj", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");


var $cStGJ = parcelRequire("cStGJ");

function $7a4dd1689b36f10f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a4dd1689b36f10f$export$20c2f8430aa388ca = /*#__PURE__*/ (0, $cStGJ.default)("h2", {
    target: "e1749x7q3"
})({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).multiple(2).px,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: "var(--ds-text-subtle, #505258)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingBottom: (0, $2azjJ.grid).multiple(0.5).px
});
const $7a4dd1689b36f10f$export$66b8cea0c448285 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1749x7q2"
})({
    name: "1d3w5wq",
    styles: "width:100%"
});
const $7a4dd1689b36f10f$export$ed1e22b72fb518f1 = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1749x7q1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':not(:first-of-type)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingTop: (0, $2azjJ.grid).multiple(3.5).px
    }
});
const $7a4dd1689b36f10f$export$1c358a11c930965b = /*#__PURE__*/ (0, $cStGJ.default)("div", {
    target: "e1749x7q0"
})({
    name: "60msyp",
    styles: "display:flex;justify-content:left;align-items:center"
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $g5lKx = parcelRequire("g5lKx");







function $61a973e22d6cdd6c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $61a973e22d6cdd6c$var$smallItemElemSpacing = (0, $2azjJ.grid).multiple(1.5).unitless;
const $61a973e22d6cdd6c$var$itemElemSpacing = (0, $2azjJ.grid).multiple(1).unitless;
const $61a973e22d6cdd6c$var$itemElemSize = (0, $2azjJ.grid).multiple(3).unitless;
const $61a973e22d6cdd6c$var$itemMinHeight = (0, $2azjJ.grid).multiple(5).unitless;
const $61a973e22d6cdd6c$var$skeletonContentHeight = (0, $2azjJ.grid).multiple(1.75).unitless / 2;
const $61a973e22d6cdd6c$var$shimmer = (0, $g5lKx.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $61a973e22d6cdd6c$var$shimmerKeyframes = (0, $9K4OG.keyframes)($61a973e22d6cdd6c$var$shimmer.keyframes);
const $61a973e22d6cdd6c$var$isSmallAvatar = (avatarShape)=>{
    return avatarShape.indexOf('small') === 0;
};
const $61a973e22d6cdd6c$var$isCircleAvatar = (avatarShape)=>{
    return avatarShape.indexOf('circle') !== -1;
};
const $61a973e22d6cdd6c$export$5d78cba328c109d7 = (avatarShape, isShimmering)=>({
        // This will render a skeleton in the "elemBefore" position.
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        ...isShimmering && {
            ...$61a973e22d6cdd6c$var$shimmer.css,
            animationName: `${$61a973e22d6cdd6c$var$shimmerKeyframes}`
        },
        marginRight: $61a973e22d6cdd6c$var$isSmallAvatar(avatarShape) ? $61a973e22d6cdd6c$var$smallItemElemSpacing : $61a973e22d6cdd6c$var$itemElemSpacing,
        width: $61a973e22d6cdd6c$var$isSmallAvatar(avatarShape) ? '14px' : $61a973e22d6cdd6c$var$itemElemSize,
        height: $61a973e22d6cdd6c$var$isSmallAvatar(avatarShape) ? '14px' : $61a973e22d6cdd6c$var$itemElemSize,
        borderRadius: $61a973e22d6cdd6c$var$isCircleAvatar(avatarShape) ? "var(--ds-radius-full, 9999px)" : "var(--ds-radius-small, 4px)",
        flexShrink: 0,
        display: 'inline-block'
    });
const $61a973e22d6cdd6c$var$itemCSS = {
    name: "1ibn8nm",
    styles: "cursor:pointer;font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);display:block;width:100%;box-sizing:border-box;background-color:transparent;border:0;outline:0;margin:0"
};
const $61a973e22d6cdd6c$export$31f9b59a0fa394ab = (width, isShimmering, textHeight)=>({
        // This will render the skeleton "text".
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        ...isShimmering && {
            ...$61a973e22d6cdd6c$var$shimmer.css,
            animationName: `${$61a973e22d6cdd6c$var$shimmerKeyframes}`
        },
        height: `${textHeight ? textHeight / 2 : $61a973e22d6cdd6c$var$skeletonContentHeight}px`,
        borderRadius: "var(--ds-radius-small, 4px)",
        flexBasis: width || '100%'
    });
const $61a973e22d6cdd6c$export$93ea78b0b020396e = /*#__PURE__*/ (0, $9K4OG.css)([
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $61a973e22d6cdd6c$var$itemCSS,
    {
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: $61a973e22d6cdd6c$var$itemMinHeight
    }
]);


const $b16f0ec52bca8901$export$fbc0ea7debdb77e = ({ avatarShape: avatarShape = 'none', width: width, isShimmering: isShimmering, textHeight: textHeight })=>{
    const avatarShapes = Array.isArray(avatarShape) ? avatarShape : [
        avatarShape
    ];
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $61a973e22d6cdd6c$export$93ea78b0b020396e)
    }, avatarShape !== 'none' ? // eslint-disable-next-line react/no-array-index-key
    avatarShapes.map((shape, idx)=>// @ts-ignore
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            key: idx,
            css: (0, $61a973e22d6cdd6c$export$5d78cba328c109d7)(shape, isShimmering)
        })) : null, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $61a973e22d6cdd6c$export$31f9b59a0fa394ab)(width, isShimmering, textHeight)
    })));
};


const $7ff04b7d42e6c7c3$export$1848b6a6bb206b21 = ({ children: children, title: title, isLoading: isLoading, avatarShape: avatarShape })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7a4dd1689b36f10f$export$ed1e22b72fb518f1), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7a4dd1689b36f10f$export$20c2f8430aa388ca), {
                children: title
            }),
            !isLoading ? children : /*#__PURE__*/ (0, $l998X.jsxs)((0, $7a4dd1689b36f10f$export$66b8cea0c448285), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b16f0ec52bca8901$export$fbc0ea7debdb77e), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b16f0ec52bca8901$export$fbc0ea7debdb77e), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $b16f0ec52bca8901$export$fbc0ea7debdb77e), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    })
                ]
            })
        ]
    });
};
const $7ff04b7d42e6c7c3$export$583c381620e3badb = ({ children: children, title: title, isLoading: isLoading, avatarShape: avatarShape = 'none' })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7a4dd1689b36f10f$export$ed1e22b72fb518f1), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7a4dd1689b36f10f$export$20c2f8430aa388ca), {
                children: title
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7a4dd1689b36f10f$export$1c358a11c930965b), {
                children: !isLoading ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $7a4dd1689b36f10f$export$66b8cea0c448285), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b16f0ec52bca8901$export$fbc0ea7debdb77e), {
                        avatarShape: avatarShape,
                        isShimmering: true
                    })
                })
            })
        ]
    });
};
module.exports["ColumnFilterGroup"] = $7ff04b7d42e6c7c3$export$1848b6a6bb206b21;
module.exports["RowFilterGroup"] = $7ff04b7d42e6c7c3$export$583c381620e3badb;

});

parcelRegister("h2kng", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $lggDm = parcelRequire("lggDm");


var $7gpC4 = parcelRequire("7gpC4");


var $9K4OG = parcelRequire("9K4OG");

var $170569abc3b939cc$export$627eaf65f9fd0753 = /*#__PURE__*/ function(OptionVariant) {
    OptionVariant["CHECKBOX"] = "CHECKBOX";
    OptionVariant["PILL"] = "PILL";
    return OptionVariant;
}({});
const $170569abc3b939cc$var$FilterItem = ({ value: value, onChange: onChange, label: label, isDisabled: isDisabled = false, icon: icon, LabelComponent: LabelComponent, variant: variant, ...rest })=>{
    const onChangeCallback = (0, $42omo.useCallback)((e)=>{
        if (variant === "PILL") onChange?.(value, !rest.isChecked);
        else onChange?.(e.target.value, e.target.checked);
    }, [
        variant,
        onChange,
        value,
        rest.isChecked
    ]);
    switch(variant){
        case "PILL":
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lggDm.PillButton), {
                selected: rest.isChecked,
                "aria-pressed": rest.isChecked,
                onClick: onChangeCallback
            }, label);
        case "CHECKBOX":
        default:
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lggDm.CheckboxWrapper), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7gpC4.default), {
                ...rest,
                value: value,
                onChange: onChangeCallback,
                // Target the svg to move to the left and down
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $9K4OG.css)({
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                    '& + svg': {
                        margin: `${"var(--ds-space-025, 2px)"} 0 0 ${"var(--ds-space-negative-050, -4px)"}`
                    }
                }),
                isDisabled: isDisabled,
                label: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lggDm.LabelWrapper), null, icon && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lggDm.IconWrapper), null, icon), /*#__PURE__*/ (0, $9K4OG.jsx)(LabelComponent, null, label))
            }));
    }
};
const $170569abc3b939cc$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo($170569abc3b939cc$var$FilterItem);
var $170569abc3b939cc$export$2e2bcd8739ae039 = $170569abc3b939cc$var$_default_1;
module.exports["OptionVariant"] = $170569abc3b939cc$export$627eaf65f9fd0753;
module.exports["default"] = $170569abc3b939cc$export$2e2bcd8739ae039;

});

parcelRegister("4Scw6", function(module, exports) {

let $38c5ea243cce1e24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $38c5ea243cce1e24$var$load("lUh9w").then(()=>parcelRequire('5F6io'));

});

parcelRegister("dIZm4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $h2kng = parcelRequire("h2kng");


var $6dP89 = parcelRequire("6dP89");


var $5dFS9 = parcelRequire("5dFS9");

const $2b6aeeb2a73299ec$export$e83a48685bfae274 = ({ onChange: onChange, filterType: filterType, filterSource: filterSource, isDisabled: isDisabled = false, smartValue: smartValue, allOptions: allOptions, collabGraphSessionId: collabGraphSessionId = '', variant: variant, ...rest })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onChangeCallback = (0, $42omo.useCallback)((id, checked)=>{
        if (checked) {
            fireAnalyticsEvent((0, $5dFS9.onFilterSelect)({
                filterId: id,
                filterSource: filterSource,
                filterType: filterType
            }));
            if (smartValue && allOptions) fireAnalyticsEvent((0, $5dFS9.selectEvent)(smartValue, allOptions, 'quickSearch', collabGraphSessionId));
        } else fireAnalyticsEvent((0, $5dFS9.onFilterUnselect)({
            filterId: id,
            filterSource: filterSource,
            filterType: filterType
        }));
        onChange?.(id, filterType, checked);
    }, [
        onChange,
        filterType,
        fireAnalyticsEvent,
        filterSource,
        smartValue,
        allOptions,
        collabGraphSessionId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h2kng.default), {
        ...rest,
        onChange: onChangeCallback,
        isDisabled: isDisabled,
        variant: variant
    });
};
module.exports["ProductFilterItem"] = $2b6aeeb2a73299ec$export$e83a48685bfae274;

});

parcelRegister("yVFeO", function(module, exports) {

let $068fe7fc2b3eec18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $068fe7fc2b3eec18$var$load("fEM7I").then(()=>parcelRequire('jh9sw'));

});

parcelRegister("fx9gO", function(module, exports) {

let $b4f120f57412454d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b4f120f57412454d$var$load("bBtaF").then(()=>parcelRequire('bK36P'));

});


//# sourceMappingURL=result-provider.e6d2d173.js.map
